import { createVanIconComponent } from "./van"

const HomeOutlined = createVanIconComponent("home-o")
export default HomeOutlined
